/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export var OrganisationRole = {
    Admin: 'ADMIN',
    Agency: 'AGENCY',
    Customer: 'CUSTOMER',
    LocationOwner: 'LOCATION_OWNER',
    NetworkOwner: 'NETWORK_OWNER'
};
export function OrganisationRoleFromJSON(json) {
    return OrganisationRoleFromJSONTyped(json, false);
}
export function OrganisationRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function OrganisationRoleToJSON(value) {
    return value;
}
